/**
 * A countdown as the game shows one, in minutes and seconds ("4:59", "0:07"), the form of the maintenance strip's
 * "Logging out in 0:42." and of an owned ground item's refusal, "That doesn't belong to you (3:12).".
 *
 * @param seconds Whole seconds left, 0 or more.
 * @returns The minutes, a colon and the seconds in two digits.
 * @example
 * countdownClock(192);
 * // "3:12"
 */
export function countdownClock(seconds: number): string {
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
}
